import * as types from '../mutation-types'

export const globalStore = {
  state: {
    isSidebarActive: false,
    isTopNavbarActive: false,
    showModalBackdrop: false
  },

  mutations: {
    [types.SHOW_MODAL_BACKDROP] (state, show) {
      state.showModalBackdrop = show
    },
    [types.TOGGLE_SIDEBAR_NAV] (state, active) {
      state.isSidebarActive = active
    },
    [types.TOGGLE_TOP_NAVBAR] (state, active) {
      state.isTopNavbarActive = active
    }
  },

  actions: {
    [types.TOGGLE_SIDEBAR_NAV] (context) {
      if (context.state.isSidebarActive) {
        context.commit(types.TOGGLE_SIDEBAR_NAV, false)
      } else {
        context.commit(types.TOGGLE_SIDEBAR_NAV, true)
      }
    },
    [types.TOGGLE_TOP_NAVBAR] (context) {
      if (context.state.isTopNavbarActive) {
        context.commit(types.TOGGLE_TOP_NAVBAR, false)
      } else {
        context.commit(types.TOGGLE_TOP_NAVBAR, true)
      }
    },
    [types.SHOW_MODAL_BACKDROP] (context, show) {
      context.commit(types.SHOW_MODAL_BACKDROP, show)
    },
    [types.UPDATE_USER_PROFILE_NAME] (context, data) {
      context.commit(types.UPDATE_USER_PROFILE_NAME, data)
    }
  }
}
